var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items
    ? _c(
        "dl",
        { staticClass: "datalist", class: [`columns-${_vm.columns}`] },
        _vm._l(_vm.filteredItems, function (item) {
          return _c("div", { staticClass: "datalist__item dataitem" }, [
            _c("dt", {
              staticClass: "dataitem__title",
              domProps: { textContent: _vm._s(item.title) },
            }),
            _vm._v(" "),
            _c(
              "dd",
              { staticClass: "dataitem__value" },
              [
                item.icon
                  ? _c("SvgIcon", { attrs: { icon: item.icon } })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  class: { sector: item.isSector ? item.isSector : false },
                  domProps: { textContent: _vm._s(item.value) },
                }),
              ],
              1
            ),
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }